
import RegisterForm from 'pages/RegisterForm';
import ValidateToken from 'pages/ValidateToken';
import LoginForm from 'pages/LoginForm';
import { Routes, Route, Navigate } from 'react-router-dom';
import ForgotPassword from 'pages/ForgotPassword';
import SetNewPassword from 'pages/SetNewPassword';
import AppSelectionPage from 'pages/AppSelectionPage';
import ExitPage from 'pages/ExitPage';
import ExtraLivestockLogin from 'pages/ExtraLivestockLogin';
import InviteValidate from 'pages/InviteValidate';
import RegisterFarmForm from 'pages/RegisterFarmForm';
import UsersPage from 'pages/Users';
import FarmDetails from './pages/FarmDetails';

const routes = (
  <Routes>
    <Route path="/" element={<LoginForm />} />
    <Route path="/exit" element={<ExitPage />} />
    <Route path="/extra-livestock-login" element={<ExtraLivestockLogin />} />
    <Route path="/register" element={<RegisterForm />} />
    <Route path="/validate" element={<ValidateToken />} />
    <Route path="/invite-validate" element={<InviteValidate />} />
    <Route path="/forgot" element={<ForgotPassword />} />
    <Route path="/setNewPassword" element={<SetNewPassword />} />
    <Route path="/app-selection" element={<AppSelectionPage />} />
    <Route path="/register-farm" element={<RegisterFarmForm />} />
    <Route path="/farm-details" element={<FarmDetails />} />
    <Route path="/users" element={<UsersPage />} />
    <Route path="/register-farm-summary" element={<Navigate to="/app-selection" replace />} />
    <Route path="*" element={<RegisterForm />} />
  </Routes>
);

export default routes;
